import React from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import SharedLensPowerCalculator from './SharedLensPowerCalculator';
const TITLE = 'Eye Lens Power Calculator - Learn How to Calculate and Understand Optical Lens Power';
const DESCRIPTION = 'The electronic Lens Power Calculator accurately calculates eye lens power with high precision and speed.';
const KEYWORDS = 'Eye lens calculation, Optical power calculation';
const OG_URL = 'https://do-calculate.com/calculator/en/lenspower';
function Calculator() {
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <p>
                                            Optical lens power represents its ability to focus rays towards the principal optical center. Lens power is denoted by the letter "C". Lens power is inversely proportional to the focal length; this means that as the focal length increases, the lens power decreases, and vice versa.
                                            <br />
                                            Lens power can be calculated using the equation C=1/F, where F represents the focal length. The value of C is positive for converging lenses and negative for diverging lenses.
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <SharedLensPowerCalculator />
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.physicsCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
